export default __webpack_public_path__ + "static/media/Buildings_Hostel3.84feb7bd.JPG";